export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/defaultSource.js
// module id = 244
// module chunks = 0